import { render } from "preact";
import "./style/index.css";
import App from "./components/app";
import { applyRuntimeBranding } from "./runtimeConfig";

applyRuntimeBranding();

(window as any).__BUILD_INFO__ = {
  version: __APP_VERSION__,
  buildTime: __BUILD_TIME__,
  test: "v2",
};

const container = document.getElementById("app");
if (container) {
  render(<App />, container);
}
